import React from 'react';
import styled from 'astroturf/react';

import { Icon } from 'js/design_system/Icon';

const MenuItemContainer = styled.button`
  @import 'stylesheets/design_system/font';
  @include body__medium-medium;

  display: flex;
  width: 100%;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
  border-radius: 0px;
  border: 0px;
  background: #fff;
  text-align: left;
  gap: 8px;
  padding: 6px 14px;
  border: 2px solid transparent;

  &:hover {
    color: var(--text-hover, #0c3b8d);
  }

  &:active {
    color: var(--text-press, #082f75);
  }

  &:focus {
    border: 2px solid var(--buttons-button-focus, #0645b1);
  }

  &:disabled {
    color: var(--text-inactive, #91919e);
  }
`;

export const MenuItem: React.FC<{
  className?: string;
  icon?: string | React.ReactNode;
  children?: React.ReactNode;
  onClick?: () => void;
}> = ({ className, icon, children, onClick }) => {
  let iconView = null;
  if (icon) {
    iconView = typeof icon === 'string' ? <Icon name={icon} /> : icon;
  }

  return (
    <MenuItemContainer className={className} onClick={onClick}>
      {iconView}
      {children}
    </MenuItemContainer>
  );
};
